import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  isAdded: false,
  id: 0,
  uid: 0,
  sid: 0,
  profileId: null,

  blockContent: {
    heading: {
      title: '',
      titleColor: '',
      titleFontSize: '',
      description: '',
      descriptionColor: '',
      descriptionFontSize: '',
      image: '',
      textAlign: '',
      divider: '',
      position: '',
    },
    items: [],
  },

  blockDesign: {
    containerDesign: {},
    itemDesign: {},
    view: 'classic',
    layout: null,
  },
};

export const pageListSlice = createSlice({
  name: 'pageList',
  initialState,
  reducers: {
    pageListStore: (state, action) => {
      const payload = action.payload ?? {};
      const { id, isActive, sid, uid, profileId, data } = payload;

      const block = data ?? {};
      const { blockContent = {}, blockDesign = {} } = block;

      const { heading = {}, items = [] } = blockContent;

      const { itemDesign = {}, containerDesign = {}, layout = null, view = null } = blockDesign;

      state.isLoading = false;
      state.isActive = isActive ?? state.isActive;
      state.id = id ?? state.id;
      state.uid = uid ?? state.uid;
      state.sid = sid ?? state.sid;
      state.profileId = profileId ?? state.profileId;

      state.blockContent = {
        items: items,
        heading: {
          ...state.blockContent.heading,
          ...heading,
        },
      };

      state.blockDesign = {
        itemDesign,
        containerDesign,
        layout,
        view: blockDesign.view ?? 'classic',
      };
    },

    pageListIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    updatePageListBlockContent: (state, action) => {
      const { heading, items } = action.payload;

      if (heading) {
        state.blockContent.heading = {
          ...state.blockContent.heading,
          ...heading,
        };
      }

      if (items) {
        state.blockContent.items = items;
      }
    },

    pageListUpdateBlockDesing: (state, action) => {
      const { itemDesign, containerDesign, layout, view } = action.payload;

      state.blockDesign = {
        ...state.blockDesign,
        itemDesign: {
          ...state.blockDesign.itemDesign,
          ...(itemDesign ?? {}),
        },
        containerDesign: {
          ...state.blockDesign.containerDesign,
          ...(containerDesign ?? {}),
        },
      };

      if (layout !== undefined) state.blockDesign.layout = layout;
      if (view !== undefined) state.blockDesign.view = view;
    },

    pageListUpdateItems: (state, action) => {
      state.blockContent.items = action.payload;
    },

    pageListIsActive: (state, action) => {
      state.isActive = action.payload;
    },

    pageListIsAdded: (state, action) => {
      state.isAdded = action.payload;
    },

    clearPageListDesign: (state) => {
      state.blockDesign.itemDesign = {};
      state.blockDesign.containerDesign = {};
    },
  },
});

export const {
  pageListStore,
  clearPageListDesign,
  pageListIsLoading,
  pageListIsActive,
  pageListUpdateBlockDesing,
  updatePageListBlockContent,
  pageListUpdateItems,
  pageListClear,
} = pageListSlice.actions;

export const selectPageListIsLoading = (state) => state.pageList.isLoading;
export const selectPageListId = (state) => state.pageList.id;
export const selectPageListIsActive = (state) => state.pageList.isActive;
export const selectPageListIsAdded = (state) => state.pageList.isAdded;
export const selectPageListBlockContent = (state) => state.pageList.blockContent;
export const selectPageListUID = (state) => state.pageList.uid;
export const selectPageItems = (state) => state.pageList.blockContent.items;
export const selectPageListBlockDesign = (state) => state.pageList.blockDesign;
export const selectPageListItemDesign = (state) => state.pageList.blockDesign.itemDesign;
export const selectPageListContainerDesign = (state) => state.pageList.blockDesign.containerDesign;

export default pageListSlice.reducer;
